// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "JavaScript/Bundles/co." + {"vendors-node_modules_vanilla-cookieconsent_dist_cookieconsent_js":"cacea9719ac6f1df7640","Assets_JavaScript_CookieConsent_js":"591386fb6873a74d658e"}[chunkId] + ".js";
};